// Área de texto con el botón de dictado — el patrón que ya usaban 012A/012B/013A/013B (motivo, resumen clínico,
// hallazgos...) y que no se pierde al pasar esos formularios a los campos del Anexo 1.
import type { JSX } from 'react';
import { BotonDictado } from '@/components/BotonDictado';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

export function AreaDictado({ id, etiqueta, valor, onChange, filas = 3 }: { readonly id: string; readonly etiqueta: string; readonly valor: string; readonly onChange: (v: string) => void; readonly filas?: number }): JSX.Element {
  return (
    <div className="flex flex-col gap-1">
      <Label htmlFor={id}>{etiqueta}</Label>
      <div className="flex items-start gap-2">
        <Textarea id={id} className="flex-1" rows={filas} value={valor} onChange={(e) => onChange(e.target.value)} />
        <BotonDictado onTranscrito={(texto) => onChange(valor ? `${valor} ${texto}` : texto)} />
      </div>
    </div>
  );
}
